<template>
    <el-dialog
    :visible="true"
    :title="$t('popper_title.select_dance_projects')"
    custom-class="codelab-popper codelab-robot-dance-projects"
    :show-close="false"
    :append-to-body="true"
    :before-close="close"
    width="500px"
    >
        <div class="projects-container">
            <el-scrollbar ref="scrollBar" v-if="!listEmpty">
                <ul class="projects-list">
                    <li
                    v-for="project in projectsList" 
                    :key="project.id"
                    class="project-item" 
                    :class="{selected: selectedIds.includes(project.id)}"
                    @click="toggleSelectProject(project.id)"
                    >
                        <div class="project-name">{{project.name}}</div>
                        <div class="project-info">
                            <div class="info-detail">{{$t("dance_info_cell_count")}} | {{$t("dance_info_cell_count_num", {count: project.cellCount})}}</div>
                            <div class="info-detail">{{$t("create_at")}} | {{formatTimeStr(project.time)}}</div>
                        </div>
                    </li>
                </ul>
            </el-scrollbar>
            <div v-else class="list-empty-tip">
                <img :src="`${baseUrl$}static/images/pic-dance-project-empty.png`" alt="">
                <div class="message">
                    {{$t("message.info_robot_dance_project_empty")}}
                </div>
            </div>
        </div>
        <div slot="footer">
            <template v-if="!listEmpty">
                <span class="popper-footer-button codelab-button gray" @click="close" tabindex="3">{{$t("button.cancel")}}</span>
                <span class="popper-footer-button codelab-button blue" @click="confirm" :class="{'disabled': selectedIds.length === 0 || lockConfirm}" tabindex="2">{{$t("button.ok")}}</span>
            </template>
            <template v-else>
                <span class="popper-footer-button codelab-button blue" @click="close" tabindex="2">{{$t("code-lab/component/layout/left-side-bar.vue_3")}}</span>
            </template>
        </div>
    </el-dialog>
</template>
<script>
import { mapState } from 'vuex';
const baseUrl$ = process.env.BASE_URL
export default {
    name: "dance-projects",
    props: {
        visible: Boolean
    },
    data(){
        return {
            baseUrl$,
            lockConfirm: false,
            projectsList: [],
            listEmpty: false,
            selectedIds: []
        }
    },
    computed: {
        ...mapState({
            projectId: state => state.projectData.projectId,
            materialsList: "materialsList",
        })
    },
    created(){
        this.getProjectsList();
    },
    methods: {
        close(){
            this.$emit('close');
        },
        confirm(){
            if(this.selectedIds.length > 0 && !this.lockConfirm){
                this.lockConfirm = true
                const projects = this.projectsList.filter(item => this.selectedIds.includes(item.id))
                this.addDanceProjects(projects).then(() => {
                    this.lockConfirm = false
                    this.close();
                })
            }
        },
        addDanceProjects(projects){
            let quickStore = this.b$.quick.store;
            let pAddDanceprojects;
            if(quickStore){
                pAddDanceprojects = this.quickAddDanceProjects(projects)
            } else {
                this.$message.error(this.$t("message.error_add_material_online", {type: this.$t("dance_project")}));
            }
            return new Promise((resolve => {
                pAddDanceprojects.then(() => {
                    this.$message.success(this.$t("message.success_add_material_online", {type: this.$t("dance_project")}));
                    resolve()
                }).catch(err => {
                    console.error("add dance file error:", err);
                    this.$message.error(this.$t("message.error_add_material_online", {type: this.$t("dance_project")}));
                    resolve()
                })
            }))
            
        },
        quickAddDanceProjects(projects){
            let promiseAll = []
            const quickStore = this.b$.quick.store;
            const { serialNumber, clientId, to } = quickStore;
            promiseAll = projects.map(project => {
                return new Promise((resolve, reject) => {
                    this.b$.send("quick", {
                    cmd: "get_dance_file",
                    data: {
                        clientId: serialNumber,
                        to: to || clientId,
                        projectId: this.projectId,
                        name: project.name,
                        id: project.id,
                        customerId: this.b$.tool.store.customerId
                    }}, res => {
                        if(res.data){
                            let materialsList = this.materialsList;
                            materialsList = [res.data, ...materialsList];
                            this.$store.commit("UPDATE_PROJECT_DATA", {materials: materialsList});
                            resolve(res.data);
                        } else {
                            reject();
                        }
                    });
                });
            })
            return Promise.all(promiseAll)
        },
        formatTimeStr(time){
            let date = new Date(time);
            return this.util$.getFormateDate$("yyyy.MM.dd", date);
        },
        getProjectsList(){
            //獲取汲取人舞蹈專案
            let quickStore = this.b$.quick.store;
            if(quickStore){
                const { serialNumber, clientId, to } = quickStore;
                this.b$.send("quick", {
                    cmd: "get_dance_list",
                    data: {
                        clientId: serialNumber,
                        to: to || clientId
                    }}, () => {}, {
                        eventName: "ws.cmd.get_dance_list",
                        callBack: res => {
                            if(res.data && res.data.length > 0){
                                this.projectsList = res.data;
                                this.listEmpty = false;
                            } else {
                                this.projectsList = [];
                                this.listEmpty = true;
                            }
                        }
                    }
                );
            }
        },
        toggleSelectProject(id){
            if(this.selectedIds.includes(id)){
                this.selectedIds = this.selectedIds.filter(item => item !== id)
            } else {
                this.selectedIds.push(id);
            }
        }
    }
}
</script>
<style lang="scss">
.codelab-popper.codelab-robot-dance-projects{
    .el-dialog__body{
        padding: 24px 10px 0 10px;
    }
    .el-dialog__footer{
        padding: 20px;
        box-shadow: 0 -35px 30px 5px rgba(51, 51, 51, 0.8);
    }
    .projects-container{
        width: 100%;
        height: 340px;
        overflow: hidden;
        .projects-list{
            width: 100%;
            overflow: hidden;
            padding: 0 20px;
            .project-item{
                width: 100%;
                height: 54px;
                padding: 7px 23px;
                margin-bottom: 15px;
                border: 3px solid transparent;
                border-radius: 27px;
                color: #ffffff;
                background: #333333;
                &:hover{
                    border-color: $--codelab-primary-blue-1;
                }
                &.selected{
                    background:$--codelab-primary-blue-2;
                    border-color: transparent;
                }
                .project-name{
                    width: 250px;
                    height: 34px;
                    line-height: 34px;
                    font-size: 22px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    float: left;
                }
                .project-info{
                    width: calc(100% - 250px);
                    float: left;
                    padding-left: 12px;
                    .info-detail{
                        width: 100%;
                        height: 17px;
                        line-height: 17px;
                        font-size: 12px;
                    }
                }
            }
        }
        .list-empty-tip{
            text-align: center;
            img{
                margin-top: 32px;
                width: 120px;
                height: 120px;
            }
            .message{
                padding: 24px 60px;
                margin-top: 15px;
                text-align: left;
                font-size: 16px;
                color: #ffffff;
                line-height: 28px;
            }
        }
    }
}
</style>